import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { FetchAsyncParams, performFetchRequest } from '@tk/utilities/tk.fetch';

type FetchParams<T> = FetchAsyncParams<T>;

export default class TKRequestManager extends TKCustomElementFactory {
    protected queue: FetchParams<unknown>[] = [];
    protected activeRequests: number = 0;
    protected maxConcurrentRequests: number;

    constructor() {
        super();
        this.maxConcurrentRequests = Number(this.getAttribute('data-tk-max-concurrent') || 3);
    }

    public async addRequest<T>(params: FetchParams<T>): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            const requestItem = {
                ...params,
                resolveHandler: (data: TKResponse<unknown>) => {
                    params.resolveHandler(data as TKResponse<T>);
                    resolve();
                },
                rejectHandler: (error: unknown) => {
                    params.rejectHandler?.(error);
                    reject(error);
                },
            };

            this.queue.push(requestItem);
            this.processQueue();
        });
    }

    protected async processQueue(): Promise<void> {
        if (this.activeRequests >= this.maxConcurrentRequests || this.queue.length === 0) {
            return;
        }

        const request = this.queue.shift()!;
        this.activeRequests += 1;

        try {
            await performFetchRequest(request);
        } finally {
            this.activeRequests -= 1;
            this.processQueue();
        }
    }
}
